export default __webpack_public_path__ + "static/media/pause_icon.ea24497f.svg";